import styled from "styled-components";

export const connector_path_styles = `

  fill: transparent;
  stroke: gray;
  stroke-width: .8;
  stroke-dasharray: 2, 3;
`
export const ConnectorPath = styled.path`
  ${connector_path_styles}
`